import RouterOutsideContainer from 'apps/ids/src/app/routers/RouterOutsideContainer'
import useLogout from 'apps/ids/src/app/hooks/useLogout'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import HealthCareServicesList from '../../healthCareServicesList/HealthCareServicesList'
import { CurrentHcsContext } from './CurrentHcsContext'
import { HcsFromUrlSelector } from './HcsFromUrlSelector'
import { CurrentHcsGuardProps } from './types'

export const CurrentHcsGuard = ({ children }: CurrentHcsGuardProps) => {
    const { logout } = useLogout()
    const { currentHcs } = useContext(CurrentHcsContext)
    const { hcsId: urlHcsId } = useParams<{ hcsId?: string }>()

    if (urlHcsId && urlHcsId !== currentHcs?.id) {
        return <HcsFromUrlSelector hcsId={urlHcsId} />
    }

    if (!currentHcs) {
        return (
            <RouterOutsideContainer>
                <HealthCareServicesList onCancel={logout} closeButtonText="Annuler (déconnexion)" />
            </RouterOutsideContainer>
        )
    }
    return children
}
